var _rect, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhoneIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.2737 19.5C27.8713 19.5 27.5473 19.176 27.5473 18.7737C27.5473 16.1175 25.3825 13.9527 22.7263 13.9527C22.324 13.9527 22 13.6287 22 13.2263C22 12.824 22.324 12.5 22.7263 12.5C26.1872 12.5 29 15.3128 29 18.7737C29 19.176 28.676 19.5 28.2737 19.5Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6887 15.5C24.514 15.5 26 16.9847 26 18.8085C26 19.1915 25.6913 19.5 25.3079 19.5C24.9245 19.5 24.6158 19.1915 24.6158 18.8085C24.6158 17.7475 23.754 16.8864 22.6921 16.8864C22.3088 16.8864 22 16.578 22 16.1949C21.9966 15.8085 22.3054 15.5 22.6887 15.5Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0897 13.7623C12.7157 13.1341 13.4928 12.7227 14.3434 12.5647C15.6029 12.3333 16.9876 12.7337 17.7499 13.5896C20.3977 16.5579 17.562 19.2874 17.5436 19.3021C18.2912 20.992 20.5486 23.2512 22.2021 23.9713C22.2205 23.9529 24.9052 21.1462 27.9175 23.7472C29.4053 25.0293 29.3648 27.8028 27.7629 29.4082C27.2178 29.9592 26.566 30.3046 25.8332 30.4368C24.6547 30.6499 23.4616 30.2862 22.4415 29.9115C17.9008 28.24 13.5259 24.1733 11.5925 19.0633C10.9444 17.3514 10.4951 15.3603 12.0897 13.7623ZM13.1355 18.5086C15.6765 24.8823 20.7254 27.4575 22.9976 28.3722C25.4391 29.3568 26.2861 28.5669 26.5992 28.2547C27.564 27.2848 27.6929 25.7199 26.7575 24.9007C25.0377 23.4018 23.399 25.0035 23.1412 25.404C22.9571 25.6868 22.5962 25.8044 22.2684 25.7199C19.9079 25.1174 16.4536 21.6752 15.787 19.2617C15.695 18.9347 15.8312 18.5968 16.0964 18.3837C16.5125 18.0457 18.0813 16.5616 16.5898 14.7505C16.1884 14.2619 14.5681 13.608 13.2534 14.9195C12.4837 15.6836 12.4211 16.7122 13.1355 18.5086Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneIcon);
export default __webpack_public_path__ + "static/media/phone-icon.cc2394962a2ba497506564d4b3c2a7f1.svg";
export { ForwardRef as ReactComponent };